export const translationStrings = [
  'error.page.not.found.message',
  'error.page.not.found.back.to.homepage.button',
] as const;
